import React from 'react';
import Container from 'react-bootstrap/Container';
import resume from '../../../resume/DILRUBA JANNAT BORNA-RESUME.pdf';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faHouse, faExclamationCircle, faTriangleCircleSquare, faReceipt, faCommentSms } from "@fortawesome/free-solid-svg-icons";
import './Header.css';


const Header = () => {
    return (
        <div>
        <Navbar expand="lg" className='navber' fixed="top">
        <Container>
        <Navbar.Brand href="#" className='name'>Portfolio</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0 header-mid nav-center"
            navbarScroll
          >
            <Nav.Link  className="nav-list" href="/home"><FontAwesomeIcon icon={faHouse} className='nav-icon'/> Home</Nav.Link>
            <Nav.Link className="nav-list mx-5" href="/About"><FontAwesomeIcon icon={faExclamationCircle} className='nav-icon'/> About</Nav.Link>
            <Nav.Link className="nav-list" href="/projects"><FontAwesomeIcon icon={faTriangleCircleSquare} className='nav-icon'/> Projects</Nav.Link>
            <Nav.Link className="nav-list mx-5" href="/blogs"><FontAwesomeIcon icon={faReceipt} className='nav-icon'/> Resources</Nav.Link>
            <Nav.Link className="nav-list" href="/contact"><FontAwesomeIcon icon={faCommentSms} className='nav-icon'/> Contact</Nav.Link>
          </Nav>
          <Nav>
            <Nav.Link className="mx-3 nav-list resume" href={resume}>
                Hire Me  
            </Nav.Link> 
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
        </div>
    );
};

export default Header;